// ja strings for messages/studioOptions.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studioOptions: Dict = {
  // Sound sheet
  "studioOptions.pitch.title": "ピッチ",
  "studioOptions.pitch.hint":
    "半音単位です。男性の声から女性の声にするなら、+12を試してください。",
  // aria-label: "{label}を下げる" with label = "Drakeのピッチ"
  "studioOptions.pitch.label": "{name}のピッチ",
  "studioOptions.pitch.maleToFemale": "男性 → 女性",
  "studioOptions.pitch.femaleToMale": "女性 → 男性",
  "studioOptions.pitch.original": "オリジナル",
  "studioOptions.stepper.lower": "{label}を下げる",
  "studioOptions.stepper.raise": "{label}を上げる",
  "studioOptions.effect.title": "エフェクト",
  "studioOptions.effect.hint":
    "一度に1つまで。もう一度タップすると解除できます。",
  "studioOptions.effect.none": "なし",
  "studioOptions.effect.onVocals": "ボーカルのみ",
  "studioOptions.effect.onSong": "曲全体",
  "studioOptions.autotune.title": "オートチューン",
  "studioOptions.autotune.switch": "ボーカルをキーに合わせる",
  "studioOptions.autotune.hint":
    "軽い補正から、はっきりしたロボットボイスまで。",
  "studioOptions.autotune.light": "弱",
  "studioOptions.autotune.medium": "中",
  "studioOptions.autotune.strong": "強",
  "studioOptions.mix.title": "ミックス",
  "studioOptions.mix.vocalVolume": "ボーカル音量",
  "studioOptions.mix.vocalVolumeHint": "伴奏に対する音量の大小（dB）。",
  "studioOptions.mix.vocalVolumeLabel": "ボーカル音量",
  "studioOptions.mix.backing": "バックコーラスを分離",
  "studioOptions.mix.backingHint":
    "ハモリやアドリブがある曲で、よりきれいに仕上がります。",
  "studioOptions.mix.vocalsOnly": "音声はボーカルのみ",
  "studioOptions.mix.vocalsOnlyHint": "ボーカルと伴奏の分離をスキップします。",
  "studioOptions.name.title": "カバー名",
  "studioOptions.name.placeholder": "任意",

  // The Sound card's one-line summary
  "studioOptions.summary.pitch": "ピッチ {values}",
  "studioOptions.summary.autotune": "オートチューン",
  "studioOptions.summary.vocals": "ボーカル {value}",
  "studioOptions.summary.backing": "バックコーラス分離",
  "studioOptions.summary.vocalsOnly": "ボーカルのみの音声",
  "studioOptions.summary.default": "オリジナルのピッチ、エフェクトなし",

  // Video sheet (Marble Run)
  "studioOptions.video.previewAria": "Marble Runのプレビュー",
  "studioOptions.video.headline":
    "ボイス同士がレース。先頭のボイスが歌います。",
  "studioOptions.video.body":
    "先頭が入れ替わると歌うボイスも交代し、歌詞は画面に表示されます。TikTokやリールにそのまま投稿できます。",
  "studioOptions.video.crown": "王冠が今歌っているボイスの目印です",
  "studioOptions.video.pickLook": "デザインを選ぶ",
  "studioOptions.video.customise": "カスタマイズ",
  "studioOptions.video.surprise": "おまかせ",
  "studioOptions.video.marbles": "ビー玉とコース",
  "studioOptions.video.sky": "空",
  "studioOptions.video.font": "歌詞のフォント",
  "studioOptions.video.stars": "空に星を表示",
  "studioOptions.theme.midnight": "ミッドナイト",
  "studioOptions.theme.neon": "ネオン",
  "studioOptions.theme.ocean": "オーシャン",
  "studioOptions.theme.royal": "ロイヤル",
  "studioOptions.theme.lava": "溶岩",
  "studioOptions.theme.gold": "ゴールド",

  // Upload view
  "studioOptions.upload.empty":
    "このファイルは空です。曲のファイルをもう一度選んでください。",
  "studioOptions.upload.tooBig":
    "ファイルサイズが75MBを超えています。小さいファイルをアップロードしてください。",
  "studioOptions.upload.tooLong":
    "音声の長さが6分を超えています。短いファイルをアップロードしてください。",
  "studioOptions.upload.invalid":
    "有効な音声ファイルをアップロードしてください",
  "studioOptions.upload.unexpected": "予期しないエラーが発生しました。",
  "studioOptions.upload.uploading": "アップロード中...",
  "studioOptions.upload.coverAlt": "カバー",
  "studioOptions.upload.dropIt": "ここにドロップ",
  "studioOptions.upload.dropHere": "音声をここにドロップ",
  "studioOptions.upload.browse": "ファイルを選択",
  "studioOptions.upload.formats": "MP3、WAV、M4A · 6分まで",
  "studioOptions.upload.dropOrBrowse":
    "音声ファイルをドロップ、またはクリックして選択",
  "studioOptions.upload.limits": "最大75MB・6分 • MP3、WAV、M4A",

  // Record view
  "studioOptions.mic.denied":
    "録音するには、ブラウザでマイクへのアクセスを許可してください。",
  "studioOptions.mic.notFound": "録音に使えるマイクが見つかりませんでした。",
  "studioOptions.mic.prepareFailed": "アップロード先の準備に失敗しました。",
  "studioOptions.mic.fileFailed": "ファイルのアップロードに失敗しました。",
  "studioOptions.mic.uploadFailed": "録音のアップロードに失敗しました。",
  "studioOptions.mic.previewFailed": "音声のプレビューを再生できませんでした。",
  "studioOptions.mic.start": "録音を開始",
  "studioOptions.mic.stop": "録音を停止",
  "studioOptions.mic.tapRecord": "タップして録音",
  "studioOptions.mic.tapStop": "タップして停止",
  "studioOptions.mic.clickRecord": "クリックして録音",
  "studioOptions.mic.processing": "処理中...",
  "studioOptions.mic.playPreview": "プレビューを再生",
  "studioOptions.mic.pausePreview": "プレビューを一時停止",
  "studioOptions.mic.yourRecording": "あなたの録音",
  "studioOptions.mic.use": "この録音を使う",
  "studioOptions.mic.again": "録音し直す",
  "studioOptions.mic.continue": "続ける",
};

export default studioOptions;
